import { z } from 'zod';
import { Id } from './primitives.js';
import { PriceObservation } from './vision.js';
/**
 * Manual SKU entry — a salesperson records a product and its price BY HAND,
 * during a visit, with no photo and no AI scan.
 *
 * WHY THIS IS NOT A CORRECTION. The FR-06 correction flow is anchored to one
 * analysed photo (`SubmitCorrectionsRequest` carries a `photoId`). This path has
 * no photo at all, so it is a visit-level write of its own: it records the same
 * fact the price index already stores — this SKU, at this outlet, at this time,
 * cost this much — as a `price_observations` row with `source = MANUAL_ENTRY`
 * and no photo or detection behind it. It is deliberately minus the planogram
 * (facing / sequence / row): a hand entry has no shelf geometry to measure, so
 * it never feeds a planogram score.
 *
 * `type` is NOT on the wire: the product carries it in master data, and the
 * server stamps the stored `sku_type` from there rather than trusting the
 * client — the same rule the correction path applies to an added item's type.
 */
export const ManualSkuEntryRequest = z.object({
    visitId: Id,
    skuId: Id,
    price: PriceObservation,
});
/**
 * Edit one manual entry — change the product, the price, or both.
 *
 * The entry's own id travels in the path (`PATCH /visits/manual-sku/:id`), so
 * only the two editable fields are on the wire. No `visitId`: the row already
 * belongs to a visit, and moving it to another one is not a thing a correction
 * means. Like the add path, `type` is NOT sent — the chosen SKU is the authority
 * on it, and the server re-stamps `sku_type` from master data.
 */
export const ManualSkuUpdateRequest = z.object({
    skuId: Id,
    price: PriceObservation,
});
//# sourceMappingURL=manual-sku.js.map